import React from "react";
import performRequest from "../../api/request";
import CustomInput from "../../CustomComponent/custom_input";
import { Form, Formik } from "formik";
import FormSubmitButton from "../../Components/layouts/formSubmitButton";
import SimpleButton from "../../Components/layouts/simple_button";
import Footer from "../../Components/Footer/footer";
import StepRoutes from "../../Routes/steps_routes";
import { useState } from "react";
import { useEffect } from "react";
import { Toast } from "../../CustomComponent/toast";
import CustomSelect from "../../CustomComponent/custom_select";
import { CustomErrorResponse } from "../../CustomComponent/custom_error_response";
import { OnboardhydrobuildSchema } from "../../Schemas/Onboard HydroBuild/onboard_hydrobuild_schema";
import { onboardHydrobuildInfo } from "../../SchemaInfo/info";
import { useNavigate } from "react-router";
import LoadingPage from "../../Components/layouts/loading";

function OnboardhydroBuild() {
  const [plantList, setPlantList] = useState();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    performRequest("GET", "/agronomyWiki/getAllAgronomyWiki/")
      .then((res) => {
        if (res.status === 200) {
          setPlantList(res?.data?.data);
        } else {
          Toast("error", "Error while getting Data!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  }, []);

  const handelSubmit = (values) => {
    values = {
      ...values,
      UID: values?.UID.trim(),
      cropId: +values?.cropId,
    };
    performRequest("POST", "/hydrobuild/hydrobuildonboard", values)
      .then((res) => {
        if (res.status === 201) {
          Toast("success", "Hydrobuild Onboarded successfully!");
          navigate(`/hydrobuild`);
        } else if (res.data?.error) {
          Toast("error", res.data?.error);
        } else {
          Toast("error", "Error while creating data!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  };
  if (loading) {
    return <LoadingPage />;
  }
  return (
    <div>
      <div className="page">
        <div className="page-wrapper">
          <div className="container-xl">
            <div className="page-header d-print-none">
              <div className="row g-2 align-items-center">
                <div className="col">
                  <h2 className="page-title mb-1">hydroBUILD automation</h2>
                  <h4 className="text-muted">
                    <StepRoutes />
                  </h4>
                </div>
              </div>
            </div>
            <div className="card my-4">
              <div className="card-header">
                <h2 className="page-title">hydroBUILD automation</h2>
              </div>
              <Formik
                initialValues={onboardHydrobuildInfo}
                validationSchema={OnboardhydrobuildSchema}
                onSubmit={handelSubmit}
                enableReinitialize
              >
                {(props) => (
                  <Form>
                    <div className="card-body">
                      <div className="row">
                        <div className="col-12 col-lg-12 col-md-12">
                          <div className="mb-3 row">
                            <label className="w-25 form-label required col-3">
                              Hydrobuild UID
                            </label>
                            <div className="w-100 col">
                              <CustomInput name="UID" type="text" />
                              {props.touched.UID && props.errors.UID && (
                                <p className="text-danger">
                                  {props.errors.UID}
                                </p>
                              )}
                            </div>
                          </div>
                          <div className="mb-3 row">
                            <label className="w-25 form-label required col-3">
                              Water tank capacity
                            </label>
                            <div className="w-100 col">
                              <CustomInput
                                name="Watertankcapacity"
                                type="text"
                              />
                              {props.touched.Watertankcapacity &&
                                props.errors.Watertankcapacity && (
                                  <p className="text-danger">
                                    {props.errors.Watertankcapacity}
                                  </p>
                                )}
                            </div>
                          </div>
                          {/* <div className="mb-3 row">
                            <label className="w-25 form-label required col-3">
                              Fertiliser Solution type
                            </label>
                            <div className="w-100 col">
                              <CustomSelect
                                type="text"
                                name="FertiliserSolutiontype"
                              >
                                <option value="">Select</option>
                                <option value="part-2"> Part 2</option>
                                <option value="part-3"> Part 3</option>
                              </CustomSelect>
                              {props.touched.FertiliserSolutiontype &&
                                props.errors.FertiliserSolutiontype && (
                                  <p className="text-danger">
                                    {props.errors.FertiliserSolutiontype}
                                  </p>
                                )}
                            </div>
                          </div> */}
                          <div className="mb-3 row">
                            <label className="w-25 form-label required col-3">
                              Fertiliser Solution PPM
                            </label>
                            <div className="w-100 col">
                              <CustomSelect
                                name="FertilisersolutionPPM"
                                type="text"
                              >
                                <option value=" ">Select</option>
                                <option value="1000 to 2000">
                                  1000 to 2000
                                </option>
                                <option value="2000 to 3000">
                                  2000 to 3000
                                </option>
                                <option value="3000 to 4000">
                                  3000 to 4000
                                </option>
                              </CustomSelect>
                              {props.touched.FertilisersolutionPPM &&
                                props.errors.FertilisersolutionPPM && (
                                  <p className="text-danger">
                                    {props.errors.FertilisersolutionPPM}
                                  </p>
                                )}
                            </div>
                          </div>
                          <div className="mb-3 row">
                            <label className="w-25 form-label required col-3">
                              Select Crop
                            </label>
                            <div className="w-100 col">
                              <CustomSelect type="text" name="cropId">
                                <option value="">Select Crop</option>
                                {plantList &&
                                  plantList?.map((plant) => {
                                    return (
                                      <option key={plant.id} value={plant.id}>
                                        {plant.name}
                                      </option>
                                    );
                                  })}
                              </CustomSelect>
                              {props.touched.cropId && props.errors.cropId && (
                                <p className="text-danger">
                                  {props.errors.cropId}
                                </p>
                              )}
                            </div>
                          </div>
{/* 
                          <div className="mb-3 row">
                            <label className="w-25 form-label required col-3">
                              Crop Type
                            </label>
                            <div className="w-100 col">
                              <CustomSelect type="text" name="Croptype">
                                <option value=" ">Select</option>
                                <option value="vegetative">vegetative</option>
                                <option value="Fruiting">Fruiting</option>
                              </CustomSelect>
                              {props.touched.Croptype &&
                                props.errors.Croptype && (
                                  <p className="text-danger">
                                    {props.errors.Croptype}
                                  </p>
                                )}
                            </div>
                          </div> */}

                          {/* <div className="mb-3 mt-5 row">
                            <div className="w-25 form-label  col-3">
                              <a
                                href="#"
                                type="button"
                                className="btn btn-primary"
                                data-bs-toggle="modal"
                                data-bs-target="#modal-simple"
                              >
                                Run Mechanism
                              </a>
                            </div>
                          </div>

                          <div
                            class="modal modal-blur fade"
                            id="modal-simple"
                            tabindex="-1"
                            role="dialog"
                            aria-hidden="true"
                          >
                            <div
                              class="modal-dialog modal-dialog-centered"
                              role="document"
                            >
                              <div class="modal-content">
                                <div class="modal-header">
                                  <h5 class="modal-title">Run Mechanism</h5>
                                  <button
                                    type="button"
                                    class="btn-close"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                  ></button>
                                </div>
                                <div class="modal-body">
                                  <div className="mb-3 row">
                                    <label className="w-25 form-label required col-3">
                                      Tank A
                                    </label>
                                    <div className="w-100 col">
                                      <CustomSelect
                                        name="TankA"
                                        type="text"
                                        onChange={(e) => {
                                          if (
                                            e.target.value ===
                                              "Time Scheduled" &&
                                            e.target.name === "TankA"
                                          ) {
                                            setTimeSchedule1(true);
                                          } else {
                                            setTimeSchedule1(false);
                                          }
                                        }}
                                      >
                                        <option value=" ">Select</option>
                                        <option value="Always On">
                                          Always On
                                        </option>
                                        <option value="Always Off">
                                          Always Off
                                        </option>
                                        <option value="Time Scheduled">
                                          Time Scheduled
                                        </option>
                                        <option value="Periodically">
                                          Periodically
                                        </option>
                                        <option value="SmartAI">
                                          Smart AI
                                        </option>
                                      </CustomSelect>
                                      {props.touched.TankA &&
                                        props.errors.TankA && (
                                          <p className="text-danger">
                                            {props.errors.TankA}
                                          </p>
                                        )}
                                    </div>
                                  </div>

                                  {timeSchedule1 ? (
                                    <div>
                                      <div className="mb-3 row">
                                        <label className="w-25 form-label required col-3">
                                          Start Date
                                        </label>
                                        <div className="w-100 col">
                                          <div className="w-100 col">
                                            <CustomInput
                                              name="startdate"
                                              type="date"
                                            />
                                            {props.touched.startdate &&
                                              props.errors.startdate && (
                                                <p className="text-danger">
                                                  {props.errors.startdate}
                                                </p>
                                              )}
                                          </div>
                                        </div>
                                      </div>
                                      <div className="mb-3 row">
                                        <label className="w-25 form-label required col-3">
                                          Start Time
                                        </label>
                                        <div className="w-100 col">
                                          <div className="w-100 col">
                                            <CustomInput
                                              name="starttime"
                                              type="time"
                                            />
                                            {props.touched.starttime &&
                                              props.errors.starttime && (
                                                <p className="text-danger">
                                                  {props.errors.time}
                                                </p>
                                              )}
                                          </div>
                                        </div>
                                      </div>

                                      <div className="mb-3 row">
                                        <label className="w-25 form-label required col-3">
                                          End Date
                                        </label>
                                        <div className="w-100 col">
                                          <div className="w-100 col">
                                            <CustomInput
                                              name="enddate"
                                              type="time"
                                            />
                                            {props.touched.enddate &&
                                              props.errors.enddate && (
                                                <p className="text-danger">
                                                  {props.errors.enddate}
                                                </p>
                                              )}
                                          </div>
                                        </div>
                                      </div>

                                      <div className="mb-3 row">
                                        <label className="w-25 form-label required col-3">
                                          End Time
                                        </label>
                                        <div className="w-100 col">
                                          <div className="w-100 col">
                                            <CustomInput
                                              name="endtime"
                                              type="date"
                                            />
                                            {props.touched.endtime &&
                                              props.errors.endtime && (
                                                <p className="text-danger">
                                                  {props.errors.time}
                                                </p>
                                              )}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  ) : (
                                    ""
                                  )}

                                  <div className="mb-3 row">
                                    <label className="w-25 form-label required col-3">
                                      Tank B
                                    </label>
                                    <div className="w-100 col">
                                      <CustomSelect
                                        name="TankB"
                                        type="text"
                                        onChange={(e) => {
                                          if (
                                            e.target.value ===
                                              "Time Scheduled" &&
                                            e.target.name === "TankB"
                                          ) {
                                            setTimeSchedule2(true);
                                          } else {
                                            setTimeSchedule2(false);
                                          }
                                        }}
                                      >
                                        <option value=" ">Select</option>
                                        <option value="Always On">
                                          Always On
                                        </option>
                                        <option value="Always Off">
                                          Always Off
                                        </option>
                                        <option value="Time Scheduled">
                                          Time Scheduled
                                        </option>
                                        <option value="Periodically">
                                          Periodically
                                        </option>
                                        <option value="SmartAI">
                                          Smart AI
                                        </option>
                                      </CustomSelect>
                                      {props.touched.TankB &&
                                        props.errors.TankB && (
                                          <p className="text-danger">
                                            {props.errors.TankB}
                                          </p>
                                        )}
                                    </div>
                                  </div>
                                  {timeSchedule2 ? (
                                    <div>
                                      <div className="mb-3 row">
                                        <label className="w-25 form-label required col-3">
                                          Start Date
                                        </label>
                                        <div className="w-100 col">
                                          <div className="w-100 col">
                                            <CustomInput
                                              name="startdate"
                                              type="date"
                                            />
                                            {props.touched.startdate &&
                                              props.errors.startdate && (
                                                <p className="text-danger">
                                                  {props.errors.startdate}
                                                </p>
                                              )}
                                          </div>
                                        </div>
                                      </div>
                                      <div className="mb-3 row">
                                        <label className="w-25 form-label required col-3">
                                          Start Time
                                        </label>
                                        <div className="w-100 col">
                                          <div className="w-100 col">
                                            <CustomInput
                                              name="starttime"
                                              type="time"
                                            />
                                            {props.touched.starttime &&
                                              props.errors.starttime && (
                                                <p className="text-danger">
                                                  {props.errors.time}
                                                </p>
                                              )}
                                          </div>
                                        </div>
                                      </div>

                                      <div className="mb-3 row">
                                        <label className="w-25 form-label required col-3">
                                          End Date
                                        </label>
                                        <div className="w-100 col">
                                          <div className="w-100 col">
                                            <CustomInput
                                              name="enddate"
                                              type="time"
                                            />
                                            {props.touched.enddate &&
                                              props.errors.enddate && (
                                                <p className="text-danger">
                                                  {props.errors.enddate}
                                                </p>
                                              )}
                                          </div>
                                        </div>
                                      </div>

                                      <div className="mb-3 row">
                                        <label className="w-25 form-label required col-3">
                                          End Time
                                        </label>
                                        <div className="w-100 col">
                                          <div className="w-100 col">
                                            <CustomInput
                                              name="endtime"
                                              type="date"
                                            />
                                            {props.touched.endtime &&
                                              props.errors.endtime && (
                                                <p className="text-danger">
                                                  {props.errors.time}
                                                </p>
                                              )}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  ) : (
                                    ""
                                  )}

                                  <div className="mb-3 row">
                                    <label className="w-25 form-label required col-3">
                                      Tank C
                                    </label>
                                    <div className="w-100 col">
                                      <CustomSelect
                                        name="TankC"
                                        type="text"
                                        onChange={(e) => {
                                          if (
                                            e.target.value ===
                                              "Time Scheduled" &&
                                            e.target.name === "TankC"
                                          ) {
                                            setTimeSchedule3(true);
                                          } else {
                                            setTimeSchedule3(false);
                                          }
                                        }}
                                      >
                                        <option value=" ">Select</option>
                                        <option value="Always On">
                                          Always On
                                        </option>
                                        <option value="Always Off">
                                          Always Off
                                        </option>
                                        <option value="Time Scheduled">
                                          Time Scheduled
                                        </option>
                                        <option value="Periodically">
                                          Periodically
                                        </option>
                                        <option value="SmartAI">
                                          Smart AI
                                        </option>
                                      </CustomSelect>
                                      {props.touched.TankC &&
                                        props.errors.TankC && (
                                          <p className="text-danger">
                                            {props.errors.TankC}
                                          </p>
                                        )}
                                    </div>
                                  </div>

                                  {timeSchedule3 ? (
                                    <div>
                                      <div className="mb-3 row">
                                        <label className="w-25 form-label required col-3">
                                          Start Date
                                        </label>
                                        <div className="w-100 col">
                                          <div className="w-100 col">
                                            <CustomInput
                                              name="startdate"
                                              type="date"
                                            />
                                            {props.touched.startdate &&
                                              props.errors.startdate && (
                                                <p className="text-danger">
                                                  {props.errors.startdate}
                                                </p>
                                              )}
                                          </div>
                                        </div>
                                      </div>
                                      <div className="mb-3 row">
                                        <label className="w-25 form-label required col-3">
                                          Start Time
                                        </label>
                                        <div className="w-100 col">
                                          <div className="w-100 col">
                                            <CustomInput
                                              name="starttime"
                                              type="time"
                                            />
                                            {props.touched.starttime &&
                                              props.errors.starttime && (
                                                <p className="text-danger">
                                                  {props.errors.time}
                                                </p>
                                              )}
                                          </div>
                                        </div>
                                      </div>

                                      <div className="mb-3 row">
                                        <label className="w-25 form-label required col-3">
                                          End Date
                                        </label>
                                        <div className="w-100 col">
                                          <div className="w-100 col">
                                            <CustomInput
                                              name="enddate"
                                              type="time"
                                            />
                                            {props.touched.enddate &&
                                              props.errors.enddate && (
                                                <p className="text-danger">
                                                  {props.errors.enddate}
                                                </p>
                                              )}
                                          </div>
                                        </div>
                                      </div>

                                      <div className="mb-3 row">
                                        <label className="w-25 form-label required col-3">
                                          End Time
                                        </label>
                                        <div className="w-100 col">
                                          <div className="w-100 col">
                                            <CustomInput
                                              name="endtime"
                                              type="date"
                                            />
                                            {props.touched.endtime &&
                                              props.errors.endtime && (
                                                <p className="text-danger">
                                                  {props.errors.time}
                                                </p>
                                              )}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  ) : (
                                    ""
                                  )}
                                </div>
                                <div class="modal-footer">
                                  <button
                                    type="button"
                                    class="btn me-auto"
                                    data-bs-dismiss="modal"
                                  >
                                    Close
                                  </button>
                                  <button
                                    type="button"
                                    class="btn btn-primary"
                                    data-bs-dismiss="modal"
                                  >
                                    Save changes
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div> */}
                        </div>
                      </div>
                    </div>
                    <div className="card-footer">
                      <div className="btn-list justify-content-end">
                        <FormSubmitButton buttonText="Create Onboard Hydrobuild" />
                        <SimpleButton buttonText="Cancel" type="secondary" />
                      </div>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
          <Footer />
        </div>
      </div>
    </div>
  );
}

export default OnboardhydroBuild;
